import { render, staticRenderFns } from "./RegisterJuridical.vue?vue&type=template&id=079ac537&scoped=true"
import script from "./RegisterJuridical.vue?vue&type=script&lang=js"
export * from "./RegisterJuridical.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegisterJuridical.vue?vue&type=style&index=1&id=079ac537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ac537",
  null
  
)

export default component.exports